import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { SubscriptionPlanPropTypes } from '../../../SubscriptionPlans/SubscriptionPlanList'
import DiscountCode from '../../../DiscountCode'
import getPlanIcon from '../../../utils/getPlanIcon'

import './styles.css'


export default class ChangeSubscriptionConfirmation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      calculatedPrice: this.initialCalculatedPrice(props),
      isProrated: props.isProrated
    }

    this.getResponse = this.getResponse.bind(this)
  }

  initialCalculatedPrice(props) {
    const entry = this.couponPlanEntry(props)
    if (entry && entry.priceDiscount) return entry.priceDiscount
    return props.newPlan.price
  }

  couponPlanEntry(props = this.props) {
    const { preAppliedCoupon, newPlan } = props
    if (
      preAppliedCoupon &&
      preAppliedCoupon.plans &&
      newPlan &&
      preAppliedCoupon.plans[newPlan.id]
    )
      return preAppliedCoupon.plans[newPlan.id]
    return null
  }

  getNewPlanGraphicPrice() {
    const entry = this.couponPlanEntry()
    if (entry && entry.priceDiscount) return entry.priceDiscount
    return this.props.newPlan.price
  }

  componentDidUpdate(prevProps) {
    const { newPlan, validatedDiscountCode, preAppliedCoupon } = this.props
    let { calculatedPrice } = this.state

    if (preAppliedCoupon) {
      const entry = this.couponPlanEntry()
      if (entry && entry.priceDiscount) calculatedPrice = entry.priceDiscount
      else calculatedPrice = newPlan.price
    } else if (
      validatedDiscountCode &&
      validatedDiscountCode.status === 'DISCOUNT_CODE_SUCCESS'
    )
      calculatedPrice = parseFloat(
        newPlan.price - validatedDiscountCode.validatedCode.discount
      ).toFixed(2)
    else if (
      prevProps.validatedDiscountCode?.status !== validatedDiscountCode?.status
    )
      calculatedPrice = newPlan.price

    if (calculatedPrice !== this.state.calculatedPrice)
      this.setState({ calculatedPrice })
  }

  getResponse() {
    const { preAppliedCoupon, validatedDiscountCode } = this.props
    if (preAppliedCoupon) return { codename: preAppliedCoupon.codename }
    return validatedDiscountCode && validatedDiscountCode.validatedCode
  }

  renderCouponSummary() {
    const { preAppliedCoupon, newPlan } = this.props
    const entry = this.couponPlanEntry()
    if (!preAppliedCoupon || !entry) return null
    const yearly = newPlan.rank > 2
    const billed = yearly ? '/year' : '/month'
    const monthly = entry.priceDiscountMonthly
      ? ` ($${entry.priceDiscountMonthly}/mo)`
      : ''
    return (
      <div className="coupon-summary">
        Promo code <strong>{preAppliedCoupon.codename}</strong> applied —
        you&rsquo;ll be charged ${entry.priceDiscount}
        {billed}
        {yearly && monthly} instead of ${newPlan.price}
        {billed}.
        <div className="coupon-sub">
          Discount lasts as long as you remain subscribed.
        </div>
      </div>
    )
  }

  render() {
    const { props } = this
    const { planInfo, newPlan, preAppliedCoupon } = props
    const showDiscountCodeForm =
      !preAppliedCoupon &&
      props.discountCode &&
      (!props.validatedDiscountCode ||
        (props.validatedDiscountCode &&
          props.validatedDiscountCode.status !== 'DISCOUNT_CODE_SUCCESS'))
    return (
      <div>
        <div className="upgrade-graphic">
          <div className="current-plan">
            <i className={getPlanIcon(planInfo.name)} />
            <span className="name">{planInfo.name}</span>
            <span>${planInfo.price}/{planInfo.rank > 2 ? 'Yr' : 'Mo'}</span>
          </div>
          <div className="arrow">➔</div>
          <div className="new-plan">
            <i className={getPlanIcon(newPlan.name)} />
            <span className="name">{newPlan.name}</span>
            <span>${this.getNewPlanGraphicPrice()}/{newPlan.rank > 2 ? 'Yr' : 'Mo'}</span>
          </div>
        </div>
        {this.state.isProrated && (
          <div>
            <div className="message">
              You are about to upgrade to a superior plan. As an upgrading subscriber, you get a Reward Discount on your first payment cycle * based on the cost of your current plan and on the time left for its expiration.
            </div>
            <div className="disclaimer">
              * Only the first payment cycle will include a Reward Discount. It does not apply any price cuts for next payment cycles.
            </div>
            <div className="total">Total cost of the first payment cycle with Subscriber Discount:</div>
            <div className="proratedValue">${newPlan.firstMonthPrice}/{newPlan.rank > 2 ? 'Yr' : 'Mo'}</div>
            <div className="totalTagline">
              Next payments cycles will be ${newPlan.regularPrice}/{newPlan.rank > 2 ? 'Yearly' : 'Monthly'}
            </div>
          </div>
        )}
        {!this.state.isProrated && (
          <div>
            <div className="message">
              You are about to upgrade your subscription plan. If you decide to upgrade now, you will start enjoying all the subscriber benefits from the {newPlan.name} plan immediately.
            </div>
            <div className="message">By upgrading now you will:</div>
            <div className="benefit">- Pay for the {newPlan.name} plan.</div>
            <div className="benefit">- Start enjoying all the {newPlan.name} subscriber benefits.</div>
            <div className="total">Total plan cost:</div>
            <div className="newValue">
              $<span id="realValue">{this.state.calculatedPrice}</span>
              {`/${newPlan.rank > 2 ? 'Yearly' : 'Monthly'}`}
            </div>
          </div>
        )}
        {this.renderCouponSummary()}
        {showDiscountCodeForm && (
          <div className="discount-code">
            {!props.displayForm && (
              <a className="subscribe" onClick={() => props.toggleDiscountCode()}>
                Redeem a discount code
              </a>
            )}
            <DiscountCode className="change-subscription" plan={props.newPlan} />
          </div>
        )}
      </div>
    )
  }
}

ChangeSubscriptionConfirmation.propTypes = {
  validatedCode: PropTypes.shape({
    codename: PropTypes.string,
    discount: PropTypes.number,
    status: PropTypes.string
  }),
  newPlan: PropTypes.shape(SubscriptionPlanPropTypes).isRequired,
  planInfo: PropTypes.shape(SubscriptionPlanPropTypes).isRequired,
  preAppliedCoupon: PropTypes.shape({
    codename: PropTypes.string,
    discount: PropTypes.number,
    discountType: PropTypes.string,
    plan: PropTypes.number,
    plans: PropTypes.object
  })
}

ChangeSubscriptionConfirmation.defaultProps = {
  validatedCode: {},
  preAppliedCoupon: null
}
